const compare = (a, b) => {
  const votesB = b.votes; 
  const votesA = a.votes;

  if (votesB < votesA) {
    return -1;
  }
  if (votesB > votesA) {
    return 1;
  }

  const insTimeA = a.insertionTime.toUpperCase();
  const insTimeB = b.insertionTime.toUpperCase();
  if (insTimeA < insTimeB) {
    return -1;
  }
  if (insTimeA > insTimeB) {
    return 1;
  }
  
  // names must be equal
  return 0;
};

module.exports = {
  compare
};
